/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\ProfilePage\ProfileInfo\ProfileInfo.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Wednesday September 20th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday September 20th 2023 9:07:45 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Box, TextField} from '@mui/material';
import { forwardRef, useState, useImperativeHandle } from 'react';
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "Content/InputText/PhoneInput.css";
import { useLang } from 'Router/LangueProvider';

type InputTextProps = {
    titleClass: string,
    holderClass: string,
    disabled: boolean,
    title: string,
    checkValues: Function,
}

export type InputTextRefType = {key: string, text: string | number | undefined, translateKey: string}[];

const InputText = forwardRef((props: InputTextProps, ref) => {
    const [data, setData] = useState<InputTextRefType>(ref !== null && typeof(ref) === "object" ? ref.current as InputTextRefType : []);
    const {translator} = useLang();

    useImperativeHandle(ref, () => {
        return data;
    }, [data]);

    return (
        <>
            <h3 className={props.titleClass}>{translator.decode(props.title)}</h3>
            <Box className={props.holderClass} component="form" sx={{'& .MuiTextField-root': { m: 1, width: "25ch" }, '& .Mui-focused': {color: "black !important"}}} autoComplete="on" >
                {
                    data.map(
                        (item) => item.key === "Phone" || item.key === "CellPhone" ?
                            <PhoneInput key={item.translateKey} autoComplete="on" value={item.text ? item.text.toString() : ""} defaultCountry="FR"
                                onBlur={() => props.checkValues()} onChange={(e) => {item.text = e?.toString()}}
                                inputComponent={ forwardRef((props: any, ref2) => { return <TextField {...props} inputRef={ref2}
                                sx={{ '& .MuiOutlinedInput-notchedOutline': {borderColor: "grey !important"}, maxWidth: "16ch"}}
                                size='small' label={translator.decode(item.translateKey)} /> })}
                            />
                            :
                            ( item.key === "Company" ?
                            <TextField onChange={(e) => {item.text = e.target.value; props.checkValues();}} onBlur={() => props.checkValues()}
                            key={item.translateKey} sx={{ '& .MuiOutlinedInput-notchedOutline': {borderColor: "grey !important"} }}
                            size='small' label={translator.decode(item.translateKey)} disabled={true}
                            id={`outlined-size-normal-${item.translateKey}`} defaultValue={item.text}/>
                            :
                            <TextField onChange={(e) => {item.text = e.target.value; props.checkValues();}} onBlur={() => props.checkValues()}
                            key={item.translateKey} sx={{ '& .MuiOutlinedInput-notchedOutline': {borderColor: "grey !important"}}}
                            size='small' label={translator.decode(item.translateKey)} disabled={props.disabled}
                            id={`outlined-size-normal-${item.translateKey}`} defaultValue={item.text}/>)
                    )
                }
            </Box>
        </>
    )
})

export default InputText;
